// Modules
import { gql } from '@apollo/client'

export const SearchLoginByCPF = gql`
    query viewerSearchLoginByCPF($username: String!) {
        viewerSearchLoginByCPF(username: $username) {
            mobile
        }
    }
`
